module.exports = __webpack_public_path__ + "static/computador2-cc968841e8e8e9cec5dba4d71f3ec5e7.svg";